import { createFileRoute, redirect } from "@tanstack/react-router";

/** Zone access codes now live as a tab of `/settings/zone-access`; the old address redirects (filters kept) so bookmarks work. */
export const Route = createFileRoute("/_app/settings/access-codes")({
	beforeLoad: ({ search }) => {
		throw redirect({ to: "/settings/zone-access", search: { ...(search as Record<string, unknown>), tab: "codes" } as never, replace: true });
	},
});
